import { change, reduxForm, submit } from 'redux-form'
import { connect, useDispatch } from 'react-redux'
import { useEffect, useState } from 'react'
import { quickActions } from '../../../../redux/actions/dashboard/quickActionActions'
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd'
import grid_icon from '../../../../itrust_common/assets/static/images/group.png'

function AddActionDropdown(props) {
  const { currentUserRole, handleSubmit, userQuickActions, saving, whatsAppConfig, showActionsDropdown, quickActionOrder } = props
  const dispatch = useDispatch()
  const [showActions, setShowActions] = useState(false)

  useEffect(() => {
    if (whatsAppConfig?.visible) {
      let items = quickActionsData
      items.splice(6, 0, whatsappAction)
      setQuickActionsData([...items])
    }
  }, [whatsAppConfig?.visible])

  useEffect(() => {
    if (showActions) {
      document.addEventListener('click', handleClickOutside)
    }
    else {
      document.removeEventListener('click', handleClickOutside)
    }
    return () => {
      document.removeEventListener('click', handleClickOutside)
    }
  }, [showActions])

  const handleClickOutside = (e) => {
    const quickActionsDropdown = document.getElementById('quickActionsDropdown')
    const quickActionDropLink = document.getElementById('quickActionDropLink')
    if (quickActionsDropdown && !quickActionsDropdown.contains(e.target) && quickActionDropLink && !quickActionDropLink.contains(e.target)) {
      setShowActions(false)
      dispatch(quickActions({ showActionsDropdown: false }))
    }
  }

  useEffect(() => {
    setShowActions(showActionsDropdown)
  }, [showActionsDropdown])

  let QuickActions = [
    { title: 'New Patient', name: 'patient', icon: 'la-user-plus' },
    { title: 'Appointment', name: 'appointment', icon: 'la-calendar', storeId: true },
    { title: 'Exam', name: 'exam', icon: 'la-stethoscope', storeId: true },
    { title: 'Order', name: 'order', icon: 'la-shopping-cart', storeId: true },
    { title: 'Prescription', name: 'prescription', icon: 'la-file-alt', storeId: true },
    { title: 'Text Message', name: 'send_text_message', icon: 'la-sms', storeId: true },
    { title: 'Phone Call', name: 'make_phone_call', icon: 'la-phone-volume', storeId: true },
    { title: 'Contact Lenses', name: 'add_contact_lens', icon: 'la-glasses', notVisibleTo: ['non_admin'], storeId: true },
    { title: 'Insurances', name: 'add_insurance', icon: 'la-medkit', notVisibleTo: ['admin', 'non_admin'], storeId: true },
    { title: 'Contacts', name: 'add_contact', icon: 'la-user-circle', notVisibleTo: ['non_admin'], storeId: true },
    // { title: 'Create Quick Sale', name: 'create_quick_sale', icon: 'la-dollar-sign' },
  ]

  const whatsappAction = { title: 'WhatsApp', name: 'whatsapp', icon: 'la-whatsapp', storeId: true }

  const [quickActionsData, setQuickActionsData] = useState(QuickActions)

  const getLabel = (action) => {
    return <span className='d-flex align-items-center line-height-normal'>
      <i className={`la ${action.icon} mr-3`} />
      <span>{action.title}</span>
    </span>
  }

  const handleChanged = (val, key) => {
    const quickActionData = { ...userQuickActions, [key]: { ...userQuickActions[key], visible: val } }
    dispatch(change('AddActionDropdown', 'quick_actions', quickActionData))
    setTimeout(() => dispatch(submit('AddActionDropdown')), 300);
  }

  function rearrange(source, destination) {
    let arr = quickActionOrder
    const item = arr.splice(source, 1)[0];
    arr.splice(destination, 0, item);
    return arr;
  }

  const onDragEnd = (dnd) => {
    let arr = rearrange(dnd.source.index, dnd.destination.index)
    dispatch(change('AddActionDropdown', 'quick_action_order', arr))
    setTimeout(() => dispatch(submit('AddActionDropdown')), 300);
  }

  return (
    <div className={`bg-white mr-10 quickActionDropdown shadow border ${showActions ? '' : 'd-none'}`} id="quickActionsDropdown">
      <DragDropContext onDragEnd={(dnd) => onDragEnd(dnd)}>
        <Droppable droppableId="droppable">
          {(provided) =>
            <form ref={provided.innerRef}>
              {provided.placeholder}
              {quickActionOrder?.map((action, index) => {
                action = quickActionsData.find(a => a.name === action) ?? {}
                if (action.notVisibleTo?.includes(currentUserRole)) return null;
                return (
                  action.name && <Draggable key={action.name} draggableId={`${action.name}`} index={index}>
                    {(providedd, snapshot) => (
                      <div ref={providedd.innerRef} {...providedd.dragHandleProps} {...providedd.draggableProps}
                        style={{ ...providedd.draggableProps.style }} className={`bg-white text-dark dropdown-item p-4 border-bottom ${saving && 'disabled'}`} key={action.name}>
                        <div className='d-flex justify-content-between'>
                          <div className="custom-control custom-checkbox">
                            <input
                              onChange={(e) => handleChanged(e.target.checked, action.name)}
                              type="checkbox"
                              checked={userQuickActions?.[action.name]?.visible}
                              className="custom-control-input"
                              id={action.name}
                            />
                            <label className="custom-control-label" htmlFor={action.name}>{getLabel(action)}</label>
                          </div>
                          <img src={grid_icon} alt="grid-icon" />
                        </div>
                      </div>)}
                  </Draggable>
                )
              })}
            </form>}
        </Droppable>
      </DragDropContext>
    </div>
  )
}

AddActionDropdown = reduxForm({
  form: 'AddActionDropdown',
  enableReinitialize: true,
  shouldValidate: () => true
})(AddActionDropdown)

const mapStateToProps = (state) => {
  const { auth: { user, saving }, organisation: { organisation }, dashboard: { quickAction } } = state
  return {
    userQuickActions: user.quick_actions,
    quickActionOrder: user.quick_action_order,
    currentUserRole: user.role,
    saving,
    whatsAppConfig: organisation.add_ons_config?.type?.whatsapp,
    showActionsDropdown: quickAction.showActionsDropdown,
    initialValues: {
      id: user.id,
      quick_actions: user.quick_actions,
      quick_action_order: user.quick_action_order
    }
  }
}

export default connect(mapStateToProps)(AddActionDropdown);